import { useTranslation } from 'react-i18next';
import MantineGrid from '../../../../../../UI/MantineGrid/ManiteGrig';
import useHttp from '../../../../../../../hooks/use-http';
import { useContext, useEffect, useState } from 'react';
import { urls } from './api/urls';
import { formatDateFromDB } from '../../../../../../../../utils/FormatDate';
import Sifra from '../../../../../../../../shared/components/Sifra';
import { TabContext } from '../../../../../../../Context/TabContext';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ChatPreview from './ChatPreview';
import MuiDialog from '../../../../../../UI/MuiDialog/MuiDialog';

const ZSGridProvider = ({ idMasine }) => {
  const { t, i18n } = useTranslation();
  const { addTab } = useContext(TabContext);
  const { sendRequest, data, getData } = useHttp('');
  const [openChat, setOpenChat] = useState(false);
  const [selectedOznaka, setSelectedOznaka] = useState('');

  const handleOpenDetail = (item) => {
    // console.log(item);
    const tab = {
      title: 'Pregled zahteva',
      icon: 'fas fa-clipboard',
      type: 10014,
      data: item,
    };
    addTab(tab);
  };

  useEffect(() => {
    sendRequest({
      method: 'POST',
      url: urls.GET_ZAHTEVE,
      data: { id: idMasine, metadata: i18n.language },
    });
  }, [i18n.language]);

  const handleClickDok = async (item) => {
    console.log('ispitivanje stringa', item.ceoBrDok.includes('RNS'));
    const config = {
      method: 'POST',
      url: item.ceoBrDok.includes('RNS')
        ? urls.GET_RADNI_NALOG_ZA_ID
        : urls.GET_PONUDE_ID,
      data: { id: item.idDok },
    };
    const response = await getData(config);
    if (response.id > 0) {
      let tab = {};
      if (item.ceoBrDok.includes('RNS')) {
        tab = {
          title: 'Radni nalog',
          icon: 'fas fa-clipboard',
          type: 10012,
          data: response,
        };
      } else {
        tab = {
          title: 'Detalji ponude',
          icon: 'fas fa-file',
          type: 10017,
          data: { pregledMasina: response },
        };
      }
      addTab(tab);
    }
  };
  const onOpenChat = (row) => {
    setSelectedOznaka(row.ceoBrDok);
    setOpenChat(true);
  };

  const columns = [
    {
      field: 'ceoBrDok',
      headerName: 'Chat',
      renderCell: (e) => (
        <ChatBubbleOutlineIcon
          onClick={(event) => {
            event.stopPropagation();
            onOpenChat(e.row.original);
          }}
          sx={{
            fontSize: 30,

            cursor: 'pointer',
            color: '#1976d2',
          }}
        />
      ),
      // size: 300,
    },
    {
      field: 'ceoBrDok',
      headerName: t('requestId'),
      renderCell: (e) => (
        <Sifra
          displayValue={e.renderedCellValue}
          onClick={() => handleOpenDetail(e.row.original)}
        />
      ),
      size: 100,
    },
    {
      field: 'naslov',
      headerName: t('title'),
      // size: 200,
    },
    {
      field: 'statusMasine',
      headerName: t('robot/moldStatus'),
      // size: 200,
    },
    {
      field: 'vrsteKvarova',
      headerName: t('malfunctionType'),
      // size: 200,
    },
    {
      field: 'datumSlanja',
      headerName: t('date'),
      renderCell: (e) => {
        return formatDateFromDB(e.row.original.datumSlanja);
      },
      // size: 200,
    },
    {
      field: 'imeKorisnikaSlanjaZahteva',
      headerName: t('reportedBy'),
      // size: 150,
    },
  ];
  const columnsDetail = [
    {
      field: 'ceoBrDok',
      headerName: t('docId'),
      renderCell: (e) => (
        <Sifra
          displayValue={e.renderedCellValue}
          onClick={() => handleClickDok(e.row.original)}
        />
      ),
      // size: 300,
    },
    {
      field: 'datum',
      headerName: t('date'),
      renderCell: (e) => {
        return formatDateFromDB(e.row.original.datum);
      },
      // size: 200,
    },
    {
      field: 'status',
      headerName: t('status'),
      // size: 200,
    },

    {
      field: 'napomena',
      headerName: t('note'),
      // size: 200,
    },
    // {
    //   field: 'title',
    //   headerName: t('title'),
    //   // size: 150,
    // },
    // {
    //   field: 'notificationDate',
    //   headerName: t('notificationDate'),
    //   // size: 150,
    // },
  ];
  return (
    <div
      style={{
        marginTop: '10px',
        height: 'fit-content',
        width: '99%',
      }}
    >
      <MantineGrid
        subRows="listaPovezenihDokumenata"
        enableTableDetail
        columns={columns}
        data={data}
        columnsDetail={columnsDetail}
      />
      <MuiDialog
        maxWidth="sm"
        open={openChat}
        title="Chat"
        content={<ChatPreview oznaka={selectedOznaka} />}
        handleClose={() => setOpenChat(false)}
        deniedText="Zatvori"
      />
    </div>
  );
};

export default ZSGridProvider;
